import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const ProductBroadbandRoutes = defineRoute({
    record: {
        route: {
            path: "/product-broadband",
            component: () => loadView(import("./ProductBroadbandTable.vue")),
        },
    },
    create: {
        route: {
            path: "/product-broadband/create",
            component: () => loadView(import("./ProductBroadbandCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/product-broadband/update/:id",
            component: () => loadView(import("./ProductBroadbandUpdate.vue")),
        },
        build(id: string) {
            return `/product-broadband/update/${id}`;
        },
    },
});
